module.exports = __webpack_public_path__ + "static/media/default.36074e75.png";